import { Link } from '@on3/ui-lib/components/Link';
import { SocialIcon } from '@on3/ui-lib/components/SocialIcon';
import { Email } from '@public/components/Svg/Email';
import { SideModuleWrapper } from '@public/components/UI/Layout/Containers/Sidebar/SideModuleWrapper';
import { type ConnectData } from '@public/store/mocks/Connect.mock';

import styles from './Connect.module.scss';

interface IConnectListProps {
  title: string;
  list: ConnectData[];
}

export const Connect = ({ list, title }: IConnectListProps) => {
  return (
    <SideModuleWrapper title={title}>
      {list.map((item, index) => {
        const { avatarSrc, socials, email } = item;

        return (
          <div className={styles.social} key={index}>
            <img
              alt="On3 Logo"
              className={styles.image}
              height={50}
              loading="lazy"
              src={`${avatarSrc}?v=2`}
              width={50}
            />
            <ul>
              {socials.map((social, idx) => (
                <li className={styles.socialitem} key={idx}>
                  <SocialIcon type={social.type} />
                  <Link
                    className={styles.link}
                    href={`https://${social.type}.com/${social.handle}`}
                  >
                    {social.displayName || social.handle}
                  </Link>
                </li>
              ))}
              {email && (
                <li className={styles.socialitem}>
                  <Email />
                  <Link className={styles.link} href={`mailto:${email}`}>
                    {email}
                  </Link>
                </li>
              )}
            </ul>
          </div>
        );
      })}
    </SideModuleWrapper>
  );
};
